// extracted by mini-css-extract-plugin
export default {"container":"eZ-z","heading":"fZ-z","links":"gZ-z","copy":"hZ-z","subCopy":"iZ-z","linksLeft":"jZ-z","linksCenter":"kZ-z","linksRight":"lZ-z","link":"mZ-z","onlyLink":"nZ-z"};